module.exports = __webpack_public_path__ + "static/media/ABDB03.dc654a39.jpg";